import { usePost } from "../usePost";
import { Rephrased, RephraseApi } from "./types";
import { jsonSerializer } from "../../utils";

export const usePostRephraseQuestion = () =>
  usePost({
    url: `${process.env.REACT_APP_BACKEND_URL}/api/v2/chat/rephrase`,
    serializer: jsonSerializer(
      (data: RephraseApi): Rephrased => ({
        questionId: data.question_id,
        questionTimestamp: data.question_timestamp,
        rephrasedPrompt: data.rephrased_prompt,
      }),
    ),
  });
